import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category/movie", label: "电影" },
  { to: "/category/tv", label: "电视剧" },
  { to: "/news", label: "资讯" },
  { to: "/about", label: "关于我们" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (event) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    navigate(`/search?q=${encodeURIComponent(value)}`);
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-1 py-2 text-sm font-medium transition-colors ${
      isActive
        ? "text-accent-600"
        : "text-foreground-700 hover:text-primary-700"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex w-full items-center justify-between gap-4 px-4 py-3 md:px-8">
        {/* Logo */}
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-lg font-black text-background-50">
            91
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            看片
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Desktop search */}
        <form
          onSubmit={handleSearch}
          className="hidden items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 md:flex lg:w-72"
        >
          <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
            <i className="ri-search-line text-base"></i>
          </span>
          <input
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            type="text"
            placeholder="搜索影视、资讯"
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
          <button
            type="submit"
            className="shrink-0 whitespace-nowrap rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            搜索
          </button>
        </form>

        {/* Mobile toggle */}
        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
          aria-label="打开菜单"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {/* Mobile panel */}
      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <form
            onSubmit={handleSearch}
            className="mb-4 flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2"
          >
            <span className="flex h-5 w-5 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              type="text"
              placeholder="搜索影视、资讯"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `border-b border-background-100 py-3 text-base font-medium ${
                    isActive ? "text-accent-600" : "text-foreground-800"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}